export var Adaptive = {
  mobile: 767,
  tablet: 1023,
  smallDesktop: 1279,
  desktop: 1439
};
export var CSS_BREAKPOINTS = {
  mobile: "(max-width: ".concat(Adaptive.mobile, "px)"),
  tablet: "(max-width: ".concat(Adaptive.tablet, "px)"),
  smallDesktop: "(max-width: ".concat(Adaptive.smallDesktop, "px)"),
  desktop: "(max-width: ".concat(Adaptive.desktop, "px)"),
  large: "(min-width: ".concat(Adaptive.desktop + 1, "px)")
};
export var QueriesTitle = /*#__PURE__*/function (QueriesTitle) {
  QueriesTitle["IsMobile"] = "isMobile";
  QueriesTitle["IsTablet"] = "isTablet";
  QueriesTitle["IsSmallDesktop"] = "isSmallDesktop";
  QueriesTitle["IsDesktop"] = "isDesktop";
  QueriesTitle["IsLarge"] = "isLarge";
  return QueriesTitle;
}({});
export var LAYOUT_TYPE = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
  DesktopSmall: 'desktopSmall'
};